"use client";

import { TrendingUp, Brain, Fingerprint, Layers, Globe, BarChart3, Repeat, Crosshair } from "lucide-react";
import { Section, Container } from "@/components/ui/container";
import { Reveal } from "@/components/ui/reveal";
import { benefits as data } from "@/lib/data/capabilities-narrative-engineering";

const iconMap = [TrendingUp, Brain, Fingerprint, Layers, Globe, BarChart3, Repeat, Crosshair] as const;
const accents = [
  "var(--color-crimson)",
  "var(--color-purple)",
  "var(--color-emerald)",
  "var(--color-cyan)",
  "var(--color-amber)",
  "var(--color-denim)",
  "var(--color-violet)",
  "var(--color-rose)",
] as const;

export function Benefits() {
  return (
    <Section id="benefits" className="relative">
      <div className="pointer-events-none absolute inset-0 -z-10">
        <div className="absolute top-1/4 right-1/4 h-80 w-80 rounded-full bg-[var(--color-emerald)] opacity-15 blur-[120px]" />
      </div>

      <Container>
        <Reveal>
          <div className="max-w-3xl">
            <span className="eyebrow-tiny text-[var(--color-emerald)]">{data.eyebrow}</span>
            <h2 className="mt-3">{data.title}</h2>
          </div>
        </Reveal>

        <div className="mt-12 grid sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {data.benefits.map((b, i) => {
            const Icon = iconMap[i % iconMap.length]!;
            const accent = accents[i % accents.length]!;
            return (
              <Reveal key={b.title} delay={i * 60}>
                <div
                  className="glass rounded-2xl p-5 h-full"
                  style={{
                    boxShadow: `inset 0 0 0 1px color-mix(in oklch, ${accent} 12%, transparent)`,
                  }}
                >
                  <span
                    className="grid place-items-center h-10 w-10 rounded-lg"
                    style={{
                      background: `color-mix(in oklch, ${accent} 18%, transparent)`,
                      boxShadow: `inset 0 0 0 1px color-mix(in oklch, ${accent} 35%, transparent)`,
                    }}
                  >
                    <Icon className="h-4 w-4" style={{ color: accent }} />
                  </span>
                  <h3 className="mt-3 text-base">{b.title}</h3>
                  <p className="mt-2 text-xs text-[rgb(var(--fg-muted))] leading-relaxed">{b.body}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </Container>
    </Section>
  );
}
